import { CobaltDivider } from '@cae/cobalt-react/components/divider';
import { ContentLoader } from '@shared/components/content-loader/ContentLoader';
import { InlineFeedback } from '@shared/components/inline-feedback/InlineFeedback';
import * as React from 'react';

import type { InstructorDetailPanelContentProps } from './InstructorDetailPanelContent.types';

import { DisciplineItem } from '../discipline-item/DisciplineItem';
import styles from './InstructorDetailPanelContent.module.css';

const InstructorDetailPanelContent = React.memo(
  ({
    instructor,
    isLoading,
    isError,
    canEdit,
    isAnyPending,
    pendingAuthorizationId,
    uploadedCaseIds,
    onRevokeOpen,
    onDisciplineAction,
  }: Readonly<InstructorDetailPanelContentProps>): React.ReactElement => {
    if (isLoading) return <ContentLoader />;
    if (isError) return <InlineFeedback type="internal-server-error" />;

    return (
      <div
        className={styles.detailsPanelContent}
        data-testid="instructor-detail-panel-content"
      >
        {instructor?.programs.map(program => (
          <div key={`program-${program.id}`}>
            <h3 className="body-02">{program.id}</h3>
            <p className={`${styles.location} body-02`}>
              {instructor?.primaryTrainingCenter.name}
            </p>
            <div className={styles.programDisciplines}>
              {program.disciplines.map(discipline => (
                <DisciplineItem
                  key={`${program.id}-${discipline.name}`}
                  discipline={discipline}
                  programId={program.id}
                  canEdit={canEdit}
                  isAnyPending={isAnyPending}
                  pendingAuthorizationId={pendingAuthorizationId}
                  uploadedCaseIds={uploadedCaseIds}
                  onRevokeOpen={onRevokeOpen}
                  onDisciplineAction={onDisciplineAction}
                />
              ))}
            </div>
            <CobaltDivider className={styles.divider} color="subtle" />
          </div>
        ))}
      </div>
    );
  }
);

InstructorDetailPanelContent.displayName = 'InstructorDetailPanelContent';
export { InstructorDetailPanelContent };
